<template>
    <div class="businessCenter">
        <!-- <div class="widthrules"> -->
            <div class="product_box">
                <!-- 详情 -->
                <div class="product_details">
                    <div class="product_details_title">
                        <el-breadcrumb separator-class="el-icon-arrow-right" class="more">
                            <el-breadcrumb-item :to="{ path: '/' }">{{ breadcrumb_item0 }}</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '/product' }">{{ breadcrumb_item1 }}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ activetitle }}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ activetitle1 }}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="product_details_content">
                        <div class="ql-container ql-snow">
                            <div class="ql-editor">
                                <div v-html="htmlText"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
        <v-footer></v-footer>
    </div>
</template>

<script>
import vFooter from '../common/footer.vue';
import { gwGetMenuList, getGWProductDetailById, getGWProductInfoList } from '@/api/index';
import "../../../src/assets/css/quill.snow.css";
export default {
    name: 'businessCenter',
    components: {
        vFooter
    },
    data() {
        return {
            breadcrumb_item0: '',
            breadcrumb_item1: '',
            languageType: '1',
            htmlText: '',
            activetitle:'',
            activetitle1:''
        };
    },
    watch: {
        $route(to, from){}
    },
    created() {
        if (sessionStorage.getItem('languageType')) { // 刷新页面时更新languageType
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.gwGetMenuList(); // 获取导航菜单
        this.getGWProductInfoList(); // 产品导航列表
        window.addEventListener('setItem', () => { // 监听setItem
            this.languageType = sessionStorage.getItem('languageType');
            this.getGWProductInfoList(); // 产品导航列表
            this.gwGetMenuList(); // 获取导航菜单
        });
    },
    methods: {
        // 导航
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then(res => {
                // console.log('导航加载tree参数必填语言',res.obj)
                this.breadcrumb_item0 = res.obj.menuList[0].guideZw;
                this.breadcrumb_item1 = res.obj.menuList[2].guideZw;
            });
        },
        // 产品导航列表
        getGWProductInfoList() {
            let params = {
                language: this.languageType
            };
            getGWProductInfoList(params).then(res => {
                // console.log('根据ID查询产品', res.obj);
                const gList = res.obj[0].gList[this.$route.query.showInfosIndex]
                this.activetitle = gList.guideZw;
                const menuId = gList.pList[this.$route.query.idx].productId;
                // console.log('产品详情id',menuId);
                this.getGWProductDetailById(menuId)
            });
        },
        // 产品详情
        getGWProductDetailById(id) {
            let params = {
                language: this.languageType,
                productId: id
            };
            getGWProductDetailById(params).then(res => {
                // console.log('根据ID查询产品详情', res.obj);
                this.activetitle1 = res.obj.backup;
                this.htmlText = res.obj.content;
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
.businessCenter {
    .product_box {
        background: #fafafa;
        position: relative;
        z-index: 10;
        margin: 0rem auto 0rem auto;
        // padding: 20px 20px 30px 20px;
        overflow: hidden;
        .product_details {
            width: 100%;
            .product_details_title {
                background: #fff;
                padding: .375rem 3.25rem;
                border-bottom: .0125rem solid #eee;
                .title_more {
                    float: left;
                    color: #000;
                    text-align: center;
                    font-size: .3rem;
                    color: #333;
                    font-weight: bold;
                }
                .more {
                    // float: right;
                    font-size: .175rem;
                }
            }
            .product_details_content {
                padding: .375rem 1.875rem;
            }
        }
    }
}
</style>
